import React, { Component } from "react";
import Switch from "react-switch";
import styles from  "../../../common/Toggle.scss";
 
class PaperlessBillingToggle extends Component {
 constructor(props) {
 super(props);
 this.state = { checked: false };
 this.handleChange = this.handleChange.bind(this);
 }
 
//  handleChange(checked) {
// this.props.handleMarketingPref(checked);
// this.setState({ checked });

 
// }
handleChange = (checked) =>{
    this.props.paperlessToggle(checked);
    checked ? window.aUtils.sendAAEvent("ToggleOn","paperlessBilling") : window.aUtils.sendAAEvent("ToggleOff","paperlessBilling");
}


render() {
 return (
 
 <label htmlFor="paperlessBilling">
 
 <Switch className="react-switch"
 id="paperlessBilling"
 checked={this.state.checked || this.props.isToggleOn}
 onChange={this.handleChange}
 handleDiameter={22}
 height={30}
 width={70}
 borderRadius={15}
 onColor="#64A000"
 offColor="#E9EAEE"
 disabled={this.props.isDisabled}
 
uncheckedIcon={
    <div className={styles.Off} data-aa-event="toggle_off">Off</div>
   }
checkedIcon={<div className={styles.On} data-aa-event="toggle_on">On</div>
   }
 
 
 />
</label>
 
 );
 }
}
export default PaperlessBillingToggle;
